/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-08-08 20:46:17
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-07 10:48:58
 * @FilePath: \合联\oms\src\utils\util.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import store from "@/store";
import router from "@/router";
import { getSelectType } from "@/api/public";
// 判断按钮权限
export const hasPermission = function (id) {
  // return true;
  let route = router.app._route;
  if (!id) {
    return true;
  }
  if (Array.isArray(id) && route && route.meta.id) {
    let isShow = false;
    id.forEach((item) => {
      if (
        store.getters.btnList[route.meta.id] &&
        store.getters.btnList[route.meta.id].indexOf(item) > -1
      ) {
        isShow = true;
      }
    });
    return isShow;
  }
  if (
    route &&
    route.meta.id &&
    store.getters.btnList[route.meta.id] &&
    store.getters.btnList[route.meta.id].indexOf(id) > -1
  ) {
    return true;
  } else {
    return false;
  }
};

// 下拉框数据获取
export const getSelectData = async (key) => {
  let res = await getSelectType(key);
  let data = [];
  if (Array.isArray(key)) {
    data = res.data.payload;
  } else {
    data = res.data.payload[key];
  }
  return data;
};

// 下拉数据转换成对象
export const changSelObj = (arr) => {
  let obj = {};
  if (arr && arr.length) {
    arr.forEach((it) => {
      obj[it.value] = it.label;
    });
  }
  return obj;
};

// 字段映射
export const fieldMap = (obj, key) => {
  return obj[key] ? obj[key] : key;
};
